import cardTemplate from '../../../../views/campaign/partials/campaign-card.html';
import listTemplate from '../../../../views/campaign/partials/campaign-list.html';

export default class CampaignItem {
    constructor() {
        this.templateMap = {
            card: cardTemplate,
            list: listTemplate
        };
        const SendBenchmarkTimeout = 10000;

        return {
            restrict: 'E',
            scope: {
                campaign: '=',
                isAbTest: '=',
                isTransaction: '=',
                status: '='
            },
            template: (elem, attrs) => {
                return this.templateMap[attrs.templateUrl];
            },
            controller: [
                '$scope', '$attrs', 'Rest', '$state', '$window', '$stateParams', '$timeout', '$filter', 'Campaign', 'SweetAlert', 'Events', 'AbTest',
                ($scope, attrs, Rest, $state, $window, $stateParams, $timeout, $filter, Campaign, SweetAlert, Events, AbTest) => {
                    $scope.clock = "Loading..";
                    $scope.showAllRecipients = false;
                    var roles = angular.fromJson($window.localStorage.getItem('roles'));
                    $scope.ruler = (roles && roles.length && roles[0].name == "Ruler");
                    $scope.startClock = () => {
                        var tick = () =>  {
                            $scope.clock = moment().format('HH:mm:ss');
                            $timeout(tick, 1000);
                        };

                        $timeout(tick, 1000);
                    };

                    $scope.countPercentage = (number, total) => {
                        let percents = (parseFloat(number / total) * 100).toFixed(1) || 0;
                            // If something went wrong but we don't want confuse the user.
                            if (percents > 100) {
                                percents = 100;
                            }
                        return percents;
                    };

                    $scope.countSendingPercentage = () => {
                        $scope.sendingPercentage = $scope.countPercentage($scope.sendBenchmark.current, $scope.sendBenchmark.total);
                    };

                    if ($scope.status === 'sending' && attrs.templateUrl === 'card' && !$scope.isAbTest && !$scope.isTransaction) {

                        let sendingProgress = () => {
                            Campaign.getSendBenchmark($scope.campaign.id).then((response) => {
                                $scope.sendBenchmark = response.data;

                                $scope.countSendingPercentage();

                                if (response.data.current <= response.data.total) {
                                    $scope.sendingStatusTimeout = $timeout(sendingProgress, SendBenchmarkTimeout);
                                }
                            }, (error) => {
                                $scope.sendingStatusTimeout = $timeout(sendingProgress, SendBenchmarkTimeout);
                            });


                        };
                        sendingProgress();

                        $scope.$on('$destroy', () => {
                            $timeout.cancel($scope.sendingStatusTimeout);
                        });
                    }

                    if ($scope.status === 'sending' && $scope.isAbTest) {
                        let sendingProgress = () => {
                            AbTest.progress($scope.campaign.id).then((response) => {
                                $scope.sendingPercentage = response;
                            });

                        };
                        sendingProgress();
                    }

                    $scope.messageTypeMap = {
                        1: 'email',
                        2: 'textMessage'
                    };

                    var showRecipientsListener = $scope.$on('recipient:toggle', (event, data) => {
                        $scope.showAllRecipients = data;
                    });

                    var initClock = () => {
                        var endTime = moment($scope.campaign.finish_at, 'YYYY-MM-DD HH:mm:ss');
                        var startTime = moment(endTime).subtract($scope.campaign.minutes, 'minutes');
                        var now = moment();

                        if (now > endTime) {
                            $scope.campaign['abPercentage'] = 100;
                            if ($scope.campaign.send_winner) {
                                $scope.campaign['finished'] = true;
                            } else {
                                angular.forEach($scope.campaign.campaigns, function(version) {
                                    if (version.id == $scope.campaign['winner_campaign_id']) {
                                        $scope.campaign['finished'] = version['campaign_status_id'] == 3;
                                    }
                                });
                            }
                        } else {

                            var percentage = (now.diff(startTime, 'seconds') / ($scope.campaign.minutes * 60)) * 100;
                            $scope.campaign['abPercentage'] = percentage.toFixed(1);

                            if ($scope.clock === "Loading..") {
                                $scope.startClock();
                            }
                        }
                    };

                    if ($scope.status == 'sent' && $scope.isAbTest) {
                        initClock();
                    }

                    var getType = function() {
                        return $scope.campaign.message_type_id == 2 ? 'text_message' : 'email';
                    };

                    function isEmail() {
                        return $scope.campaign.message_type_id === 1;
                    }

                    function unableCopy() {
                        return isEmail() && !$scope.campaign.emails.length
                    }

                    function handleCopyError() {
                        let text = $filter('translate')($scope.campaign.campaign_status_id === 1
                            ? 'CAMPAIGN:FLASH:COPY_DRAFT_ERROR_BODY'
                            : 'CAMPAIGN:FLASH:COPY_ERROR_BODY');
                        SweetAlert.swal({
                            title: $filter('translate')('CAMPAIGN:FLASH:COPY_ERROR_TITLE'),
                            text,
                            type: 'warning',
                            confirmButtonText: $filter('translate')('GLOBAL:YES')
                        });
                    }

                    $scope.restart = function() {
                        Campaign.restart($scope.campaign.id).then(function() {
                            Events.flashEvent('notification', $filter('translate')('CAMPAIGN:INDEX:RESTARTED'));
                            $state.go('campaign.folder', { folder: 'sending', view: $stateParams.view});
                        });
                    };

                    $scope.goToCampaign = function() {
                        if ($scope.isAbTest && $scope.campaign.campaign_status_id == 2 || $scope.campaign.campaign_status_id == 6) {
                            return;
                        }

                        var campaign = $scope.isAbTest ? $scope.campaign.campaigns[0] : $scope.campaign;

                        if (campaign.campaign_status_id == 2) {
                            return $scope.goToStatistics(campaign);
                        }

                        $state.go('campaign.edit', { id: campaign.id, type: getType(campaign) });
                    };

                    $scope.copy = function() {
                        let email_template_id;
                        if (unableCopy()) {
                            return handleCopyError();
                        }
                        if (isEmail()) {
                            let email = $scope.campaign.emails[0];
                            email_template_id = isEmail() ? email && email.email_template_id : null;
                        }
                        Campaign.copy($scope.campaign.id, $scope.campaign.message_type_id, email_template_id).then(() => {
                            Events.flashEvent('notification', $filter('translate')('CAMPAIGN:FLASH:COPY'));
                            var view = $stateParams.view;

                            if (! view) {
                                var preferences = $window.localStorage.getItem('settings.campaign.view');
                                view = preferences ? preferences : 'cards';
                            }

                            $state.go('campaign.folder', { folder: 'draft', view: view }, { reload: true });
                        }, error => {
                            for (let errorKey in error.data.errors) {
                                if (errorKey === 'email_template_id') {
                                    return handleCopyError();
                                }
                            }
                        });
                    };

                    $scope.goToStatistics = function(campaign) {
                        var stateName = $scope.isAbTest ? 'campaign.abTestStatistics' : 'campaign.show';
                        var folderName = campaign.message_type_id == 2 ? 'received' : 'open';
                        var messageType = $scope.messageTypeMap[campaign.message_type_id];
                        $state.go(stateName, {
                            id: campaign.id,
                            folder: folderName,
                            messageType: messageType
                        });
                    };

                    $scope.goToSummary = function(campaign) {
                        if ($scope.isAbTest) {
                            campaign = campaign.campaigns[0];
                        }

                        $state.go('campaign.summary', { id: campaign.id, type: getType(campaign) });
                    };

                    $scope.remove = function() {
                        SweetAlert.swal({
                                title: $filter('translate')('GLOBAL:FLASH:DELETE'),
                                text: $filter('translate')('CAMPAIGN:FLASH:DELETE_EXPLAINED'),
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonText: $filter('translate')('GLOBAL:YES'),
                                cancelButtonText: $filter('translate')('GLOBAL:NO')
                            },
                            function(isConfirm) {
                                if (isConfirm) {
                                    Campaign.destroy($scope.campaign.id).then(function() {
                                        $scope.campaign['removed'] = true;
                                        Events.flashEvent('notification', $filter('translate')('CAMPAIGN:FLASH:DELETED_EXPLAINED'));
                                        $state.reload($state.current);
                                    });
                                }
                            }
                        );
                    };

                    $scope.removeAbTest = function() {
                        SweetAlert.swal({
                                title: $filter('translate')('GLOBAL:FLASH:DELETE'),
                                text: $filter('translate')('CAMPAIGN:AB_TEST:FLASH:DELETE_EXPLAINED'),
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonText: $filter('translate')('GLOBAL:YES'),
                                cancelButtonText: $filter('translate')('GLOBAL:NO')
                            },
                            function(isConfirm) {
                                if (isConfirm) {
                                    AbTest.destroy($scope.campaign.id).then(function() {
                                        $scope.campaign['removed'] = true;
                                        Events.flashEvent('notification', $filter('translate')('CAMPAIGN:AB_TEST:FLASH:DELETED_EXPLAINED'));
                                        $state.reload($state.current);
                                    });
                                }
                            }
                        );
                    };

                    $scope.campaignPercent = function(number) {
                        try {
                            var totalSent = $scope.isAbTest ? $scope.campaign.statistics.received : $scope.campaign.total_sent;
                            var percentage = parseFloat(number / totalSent) * 100 || 0;
                            return (percentage == 100 || percentage == 0) ? percentage : percentage.toFixed(1);
                        } catch (error) {
                            return 0;
                        }
                    };

                    $scope.pause = function () {
                        Campaign.pause($scope.campaign.id).then(function () {
                            Events.flashEvent('notification', $filter('translate')('CAMPAIGN:PAUSED:SUCCESS'));
                            $state.go('campaign.folder', { folder: 'paused', view: $stateParams.view});
                        })
                    };

                    $scope.pauseAbTest = function () {
                        AbTest.pause($scope.campaign.id).then(function () {
                            Events.flashEvent('notification', $filter('translate')('CAMPAIGN:AB_TEST:PAUSED:SUCCESS'));
                            $state.go('campaign.folder', { folder: 'paused', view: $stateParams.view});
                        })
                    };

                    $scope.restartAbTest = function () {
                        AbTest.restart($scope.campaign.id).then(function () {
                            Events.flashEvent('notification', $filter('translate')('CAMPAIGN:AB_TEST:RESTARTED'));
                            $state.go('campaign.folder', { folder: 'sending', view: $stateParams.view});
                        })
                    };

                    $scope.goToTransaction = function(transaction) {
                        $state.go('campaign.transactionshow', {
                            id: transaction.id,
                            folder: 'open',
                            messageType: 'email'
                        });
                    };

                    $scope.transactionalPercent = function(number, totalSent) {
                        if (! number || totalSent == 0) {
                            return 0;
                        } else {
                            return (parseFloat(number / totalSent) * 100).toFixed(1) || 0;
                        }
                    };

                    $scope.enablePreview = function() {
                        return ! $scope.isAbTest && $scope.campaign.campaign_status_id == 3
                    };

                    $scope.$on('$destroy', showRecipientsListener);
                }
            ]
        }
    }
}
